import React, { useState } from "react";
import "../InputField/InputFieldOutlined.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const InputFieldOutlined = ({
  placeholderText,
  textType,
  value,
  onChangeTextField,
  name,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = textType === "password";

  return (
    <div className="input_field_outlined_main" style={{ position: "relative" }}>
      <input
        type={
          isPassword
            ? showPassword
              ? "text"
              : "password"
            : textType === "text"
            ? "text"
            : "text"
        }
        name={name}
        value={value}
        onChange={(e) => onChangeTextField(e)}
        placeholder={placeholderText}
        className="input_field_css_outlined"
      />

      {isPassword && (
        <span
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: "absolute",
            right: "15px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
          }}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </span>
      )}
    </div>
  );
};

export default InputFieldOutlined;